import Splide from '@splidejs/splide';

export default function initSlider() {
    const d = document;
    const b = document.body;
    const w = window;
    // custom pagination ( ie: 01/ 05 )
    const pagi_selector = "splide--paginated";
    w.splides = [];

    var elms = document.getElementsByClassName( 'splide' );
    elms = Array.prototype.slice.call(elms);
    for ( var i = 0, len = elms.length; i < len; i++ ) {        
        
        let el = i;
        w.splides[i] = new Splide( elms[ i ], {
            breakpoints: {
                640: {
                    perPage: 1,
                },
          }
        } ).mount();


        w.splides[i].on( 'move', () => {
            elms[ el ].classList.add('is-moving');
        });
        w.splides[i].on( 'moved', () => {
            elms[ el ].classList.remove('is-moving');
        });

        // init custom pagination
        if(  elms[ i ].classList.contains("splide--ttb") ) {
            const $el = $(".splide__pagination--ttb");
            const $el_cont = $(".pageHeader__container .container");
            console.log( $el_cont );
            $el_cont.append($el);
        }

        if(  elms[ i ].classList.contains(pagi_selector) ) {
            // cache elements
            let current = elms[i].querySelector('.slider__pagination-current');
            let total = elms[i].querySelector('.slider__pagination-total');

            total.innerHTML = minTwoDigits(w.splides[i].length);

            w.splides[i].on( 'moved', function(e) {
                current.innerHTML = minTwoDigits(e + 1);
            });
        }
    }
    function minTwoDigits(n) {
        return (n < 10 ? '0' : '') + n;
    }
}